import { PaymentMethodConfigTypes } from './PaymentMethodConfig';

interface PaymentMethodBase {
  id: string;
  name: string;
  shortName: string;
  active: boolean;
  bookkeepingAccount: string;
}

export enum VivaOnboardingStatus {
  IN_PROGRESS = 'IN PROGRESS',
  VERIFIED = 'VERIFIED',
}

export enum FeeTypes {
  PERCENTAGE = 'PERCENTAGE',
  AMOUNT = 'AMOUNT',
}

interface TidypayPaymentMethod extends PaymentMethodBase {
  type: PaymentMethodConfigTypes.TIDYPAY;
  accountId: string;
}

interface NetsTerminalPaymentMethod extends PaymentMethodBase {
  type: PaymentMethodConfigTypes.NETS_TERMINAL;
  terminalId: string;
  username: string;
  password: string;
  acquirer: string;
  acquirerNumber: string;
  mccCode: string;
  boughtViaEnklakassan: boolean;
}

interface VivaWalletPaymentMethod extends PaymentMethodBase {
  type: PaymentMethodConfigTypes.VIVA_WALLET;
  accountId: string;
  onboardingStatus: VivaOnboardingStatus;
  onboardingUrl: string;
  ISVFee?: {
    amount: number;
    type: FeeTypes;
  };
  noISV?: boolean;
  merchantId?: string;
}

interface VivaWalletTerminalPaymentMethod extends PaymentMethodBase {
  type: PaymentMethodConfigTypes.VIVA_WALLET_TERMINAL;
  terminalId: string;
  terminalMerchantId: string;
  ISVFee?: {
    amount: number;
    type: FeeTypes;
  };
  merchantId?: string;
}

interface SoftpayPaymentMethod extends PaymentMethodBase {
  type: PaymentMethodConfigTypes.SOFTPAY;
  accountId: string;
}

interface FortnoxInvoicePaymentMethod extends PaymentMethodBase {
  type: PaymentMethodConfigTypes.FORTNOX_INVOICE;
  isOrder: boolean;
  orderLocationText?: string;
}

interface ExternalCardMachinePaymentMethod extends PaymentMethodBase {
  type: PaymentMethodConfigTypes.EXTERNAL_CARD_MACHINE;
}

type PaymentMethod =
  | TidypayPaymentMethod
  | NetsTerminalPaymentMethod
  | VivaWalletPaymentMethod
  | SoftpayPaymentMethod
  | VivaWalletTerminalPaymentMethod
  | FortnoxInvoicePaymentMethod
  | ExternalCardMachinePaymentMethod;

export type {
  PaymentMethod,
  TidypayPaymentMethod,
  NetsTerminalPaymentMethod,
  VivaWalletPaymentMethod,
  SoftpayPaymentMethod,
  VivaWalletTerminalPaymentMethod,
  ExternalCardMachinePaymentMethod,
};
